import { DataResult } from '@progress/kendo-data-query';

export class ColumnMap {
  public nameToColumn: Map<string, string>;
  public columnToName: Map<string, string>;

  constructor(public name: string, public columnname?: string) {
    if (!this.columnname) {
      this.columnname = name;
    }

    this.nameToColumn = new Map<string, string>();
    this.nameToColumn.set(name, this.columnname);
    this.columnToName = new Map<string, string>();
    this.columnToName.set(this.columnname, name);
  }

  public getColumnName(name: string) {
    return this.nameToColumn.get(name);
  }

  public getName(column: string) {
    return this.columnToName.get(column);
  }
}

export class TypedDataResult<t> implements DataResult {
  public data: t[];
  public total: number;
}